import * as ActionTypes from '../constants/ActionTypes';

/* This resets all reducers to initial state */
export function reset(query) {
    return dispatch => {
        dispatch({ type: ActionTypes.NAVIGATION_RESET, query });
        dispatch({ type: ActionTypes.RESET });
    };
}

export * from './defaultActions';

export * from './navigationActions';

export * from './statsActions';



// WEBPACK FOOTER //
// ./src/actions/actions.js